import React, { memo } from 'react';
import IconPlus from 'design-system/icons/IconPlus';
import IconCheck from 'design-system/icons/IconCheck';
import useColors from 'hooks/useColors';
import WatchListItem from './WatchListItem';
import { useStockMeta, useWatchListStockInfoMap } from '../hooks/selectors';
import useAddRemoveSymbolFromWatchList from '../hooks/useAddRemoveSymbolFromWatchList';
const WatchListItemWithActions = (props) => {
    const isStockInWatchList = useWatchListStockInfoMap(props.id, props.assetId);
    const stockCache = useStockMeta(props.assetId);
    const symbol = stockCache?.symbol;
    const [loading, addSymbolToWatchList, removeSymbolFromWatchList] = useAddRemoveSymbolFromWatchList(props.id);
    const onAddOrRemovePress = () => {
        if (symbol) {
            if (isStockInWatchList) {
                removeSymbolFromWatchList(symbol, props.assetId);
                return;
            }
            if (stockCache?.name) {
                addSymbolToWatchList(symbol, props.assetId, stockCache.name);
            }
        }
    };
    const colors = useColors();
    return (<WatchListItem {...props} disabled={loading} onPressItem={onAddOrRemovePress} RightComponent={isStockInWatchList ? (<IconCheck alt color={colors.elements.brand} width={16}/>) : (<IconPlus color={colors.text.secondary}/>)}/>);
};
export default memo(WatchListItemWithActions);
